<div class="table-container" [ngStyle]="heightTableViewContainer">
  <table
    mat-table
    [dataSource]="data"
    class="table"
    [class]="tableClassName"
    [ngStyle]="getTableStyling()"
    aria-label="shared-table-component"
  >
    <ng-container
      *ngFor="let item of displayedColumnDetails; let i = index"
      [matColumnDef]="item.property"
    >
      <ng-container *ngIf="i === 0 && active">
        <th
          id="shared-table-header-first-custom-column"
          mat-header-cell
          *matHeaderCellDef
          [class]="headerClassName"
        >
          <ng-container *ngIf="headerTemplateRef" [ngTemplateOutlet]="headerTemplateRef">
          </ng-container>
        </th>
      </ng-container>

      <ng-container
        *ngIf="i === displayedColumnDetails.length - 1 && customizeLastColumn"
      >
        <th
          id="shared-table-header-last-custom-column"
          mat-header-cell
          *matHeaderCellDef
          [class]="headerClassName"
        >
          <ng-container
            *ngIf="lastColumnHeaderTemplateRef"
            [ngTemplateOutlet]="lastColumnHeaderTemplateRef"
          >
          </ng-container>
        </th>
      </ng-container>
      <ng-container *ngIf="!(i === 0 && active)">
        <th
          [id]="'shared-table-header-' + i"
          [ngStyle]="getColumnStyling(item)"
          mat-header-cell
          *matHeaderCellDef
          [class]="headerClassName"
        >
          <div
            class="shared-table-header-content"
            [id]="'shared-table-header-content-' + i"
          >
            <app-text
              [class]="item.columnClassName"
              [textStyleType]="tableHeaderClass"
              [id]="'shared-table-header-content-text-' + i"
              >{{ item.display | translate }}</app-text
            >
            <div
              [ngClass]="getHeaderClassName(item)"
              [id]="'shared-table-header-sort-icon-divider-' + i"
            >
              <app-icon
                *ngIf="isColumnSorting"
                class="shared-table-header-sort-icon"
                [id]="'shared-table-header-sort-icon-' + i"
                [name]="columnState[i].sorted || defaultSortingIcon"
                [size]="'1.5em'"
                (iconClicked)="triggeredSortingIconClick(item)"
              ></app-icon>
              <!-- VERTICAL LINE DIVIDER BETWEEN COLUMNS HEADERS -->
              <span
                class="column-divider"
                *ngIf="
                  displayedColumnDetails[i]?.columnHeaderDividerType ===
                  columnDividerTypes.VERTICAL_LINE
                "
                [id]="'core-custom-row-table-column-header-divider-' + i"
              ></span>
            </div>
          </div>
        </th>
      </ng-container>
      <!-- TABLE ROWS -->
      <ng-container *ngIf="i === 0 && active">
        <td mat-cell *matCellDef="let element" [ngClass]="{ disabled: element.disabled }">
          <ng-container
            *ngIf="rowTemplateRef"
            [ngTemplateOutlet]="rowTemplateRef"
            [ngTemplateOutletContext]="{ $implicit: element }"
          >
          </ng-container>
        </td>
      </ng-container>
      <ng-container
        *ngIf="i === displayedColumnDetails.length - 1 && customizeLastColumn"
      >
        <td mat-cell *matCellDef="let element" [ngClass]="{ disabled: element.disabled }">
          <ng-container
            *ngIf="lastColumnValueTemplateRef"
            [ngTemplateOutlet]="lastColumnValueTemplateRef"
            [ngTemplateOutletContext]="{ $implicit: element }"
          >
          </ng-container>
        </td>
      </ng-container>

      <ng-container *ngIf="!(i === 0 && active)">
        <td
          mat-cell
          *matCellDef="let element; let ind = index"
          [class]="rowClassName"
          [ngClass]="{ disabled: element.disabled }"
          (click)="getRowData(element)"
        >
          <div class="shared-table-cell-content">
            <ng-container *ngIf="customRowTemplateRef; else defaultTableCellTemplate">
              <ng-container
                *ngTemplateOutlet="
                  customRowTemplateRef;
                  context: {
                    $implicit: element,
                    columnConfig: item
                  }
                "
              ></ng-container>
            </ng-container>

            <!-- For the default -->
            <ng-template #defaultTableCellTemplate>
              <app-text
                [id]="'shared-table-default-row-text-' + item.property + ind"
                [class]="item.columnClassName"
                *ngIf="!item.multivaluedDisplay"
                [textStyleType]="getColumnClass(item)"
                >{{ convertValueToString(element[item.property]) }}
              </app-text>

              <app-text
                *ngIf="
                  item.multivaluedDisplay &&
                  convertValueToString(element[item.property]).length <= showTextUpto
                "
                [textStyleType]="getColumnClass(item)"
                >{{ convertValueToString(element[item.property]) }}
              </app-text>

              <app-tooltip
                *ngIf="
                  item.multivaluedDisplay &&
                  convertValueToString(element[item.property]).length > showTextUpto
                "
                [tootltipText]="element[item.property]"
                [tooltipDelay]="'10'"
                [tooltipPosition]="'above'"
              >
                <div class="tooltip-content">
                  <app-text class="tooltip-content" [textStyleType]="textClassName">{{
                    getTooltipContent(element[item.property])
                  }}</app-text>
                </div>
              </app-tooltip>
            </ng-template>

            <!-- Suffix content for cell -->
            <ng-container
              *ngTemplateOutlet="
                suffixCellContentTemplate;
                context: { $implicit: { columnData: this.item, cellData: this.element } }
              "
            ></ng-container>
          </div>
        </td>
      </ng-container>
      <!-- TABLE FOOTER -->
      <ng-container *ngIf="i === 0 && active">
        <td mat-footer-cell *matFooterCellDef [class]="footerClassName">
          <ng-container *ngIf="footerTemplateRef" [ngTemplateOutlet]="footerTemplateRef">
          </ng-container>
        </td>
      </ng-container>
      <ng-container
        *ngIf="i === displayedColumnDetails.length - 1 && customizeLastColumn"
      >
        <td mat-footer-cell *matFooterCellDef [class]="footerClassName">
          <ng-container
            *ngIf="lastColumnFooterTemplateRef"
            [ngTemplateOutlet]="lastColumnFooterTemplateRef"
          >
          </ng-container>
        </td>
      </ng-container>
      <ng-container *ngIf="!(i === 0 && active)">
        <td mat-footer-cell *matFooterCellDef [class]="footerClassName">
          <app-text
            [id]="'shared-table-default-footer-text-' + item.property"
            [class]="item.columnClassName"
            [textStyleType]="tableHeaderClass"
          >
            {{ footers[i] | translate }}
          </app-text>
        </td>
      </ng-container>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <ng-container *ngIf="showFooter">
      <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
    </ng-container>

    <ng-container matColumnDef="groupHeader" *ngIf="groupHeader">
      <td colspan="999" mat-cell *matCellDef="let groupBy" [class]="groupHeaderClassName">
        {{ groupBy.value | uppercase }}
      </td>
      <tr mat-row *matRowDef="let row; columns: ['groupHeader']; when: isGroup"></tr>
    </ng-container>
  </table>
</div>

<div *ngIf="isRowDataLoading" id="shared-table-content-loader-wrapper" class="loader">
  <app-spinner id="shared-table-content-loader" [diameter]="'medium'"></app-spinner>
</div>
